import { useEffect } from 'react'
import { View } from 'react-native'
import Animated, {
  Easing,
  cancelAnimation,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated'
import { colors } from '@ui/colors'
import { LoaderOuter, LoaderInner } from './assets/loader'
import { AnimationComponentProps as Props } from './phaseAnimation'

const REFERENCE_SIZE = 24
const DURATION_OUTER = 1000
const DURATION_INNER = 1200

export default function LoaderDouble({
  size = REFERENCE_SIZE,
  color = colors.white,
  isActive = true,
}: Props) {
  const outerRotation = useSharedValue(0)
  const innerRotation = useSharedValue(0)

  useEffect(() => {
    if (!isActive) {
      cancelAnimation(outerRotation)
      cancelAnimation(innerRotation)
      return
    }

    outerRotation.set(0)
    innerRotation.set(0)

    outerRotation.set(
      withRepeat(
        withTiming(360, { duration: DURATION_OUTER, easing: Easing.linear }),
        -1,
        false
      )
    )

    innerRotation.set(
      withRepeat(
        withTiming(-360, { duration: DURATION_INNER, easing: Easing.linear }),
        -1,
        false
      )
    )
  }, [isActive, outerRotation, innerRotation])

  const outerStyle = useAnimatedStyle(() => ({
    transform: [{ rotate: `${outerRotation.value}deg` }],
  }))

  const innerStyle = useAnimatedStyle(() => ({
    transform: [{ rotate: `${innerRotation.value}deg` }],
  }))

  return (
    <View
      style={{ width: size, height: size }}
      className="items-center justify-center"
    >
      {/* Absolute wrappers need explicit dimensions on native: without
          them the view collapses to 0x0 and the SVG at 100% renders nothing. */}
      <Animated.View
        className="absolute"
        style={[{ width: size, height: size }, outerStyle]}
      >
        <LoaderOuter size="100%" color={color} />
      </Animated.View>
      <Animated.View
        className="absolute"
        style={[{ width: size, height: size }, innerStyle]}
      >
        <LoaderInner size="100%" color={color} />
      </Animated.View>
    </View>
  )
}
